import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';

@Component({
  selector: 'app-common-modules-for-countries',
  templateUrl: './common-modules-for-countries.component.html',
  styleUrls: ['./common-modules-for-countries.component.scss']
})
export class CommonModulesForCountriesComponent implements OnInit {


  @Input() isVPMNCountryRequired;
  @Input() isVPMNNetworkRequired;
  @Input() isVPMNTadigRequired;

  @Input() isHPMNCountryRequired;
  @Input() isHPMNNetworkRequired;
  @Input() isHPMNTadigRequired;

  @Output() selectedVpmnCountry = new EventEmitter();
  @Output() selectedVpmnNetwork = new EventEmitter();
  @Output() selectedVpmnTadig = new EventEmitter();

  @Output() selectedHpmnCountry = new EventEmitter();
  @Output() selectedHpmnNetwork = new EventEmitter();
  @Output() selectedHpmnTadig = new EventEmitter();

  vpmnCountryArrayDetails: any;
  vpmnNetworkArrayDetails: any;
  vpmnTadigArrayDetails: any;
  commonForm: FormGroup;


  constructor(private formBuilder: FormBuilder, private spinnerService: Ng4LoadingSpinnerService, private endpointsService: EndpointsService,
    private backendApiService: BackendApiService) { }

  ngOnInit(): void {
    this.createForm();
    this.getVpmnCountryDetails();
  }

  createForm() {
    this.commonForm = this.formBuilder.group({
      vpmnCountry: ['All'],
      vpmnNetwork: ['All'],
      vpmnTadig: ['1'],
      hpmnCountry: ['1'],
      hpmnNetwork: ['1'],
      hpmnTadig: ['1'],
    });

    if (this.isVPMNCountryRequired) {
      this.selectedVpmnCountry.emit({ vpmnCountry: 'All' });
    }
    if (this.isVPMNNetworkRequired) {
      this.selectedVpmnNetwork.emit({ vpmnNetwork: 'All' });
    }
    if (this.isVPMNTadigRequired) {
      this.selectedVpmnTadig.emit({ vpmnTadig: '1' });
    }
  }

  async getVpmnCountryDetails() {
    this.spinnerService.show();
    const apiUrl = this.endpointsService.COUNTRY_DETAILS + '&userName=' + sessionStorage.getItem('ecowas_user_name');
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.vpmnCountryArrayDetails = response;
    });
  }

  getVpmnNetworkAccordingToCountry(event: any) {
    this.getVpmnNetworkList(event.target.value).then();
    this.selectedVpmnCountry.emit({ vpmnCountry: event.target.value });
    if (event.target.value === '1') {
      this.selectedVpmnNetwork.emit({ vpmnNetwork: '1' });
    }
  }


  async getVpmnNetworkList(country: string) {
    const apiUrl1 = this.endpointsService.URL_GET_OPERATOR_LIST_BY_COUNTRY +
      '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&country=' + country;
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
      this.vpmnNetworkArrayDetails = response;
      // if (this.vpmnNetworkArrayDetails && this.vpmnNetworkArrayDetails.length > 0) {
      //   this.commonForm.controls.vpmnNetwork.setValue(response[0].operator, { onlySelf: true });
      // }
    });
  }

  getVPMNTadigDetails(event: any) {
    this.getVpmnTadigFromApi(event.target.value).then();
    this.selectedVpmnNetwork.emit({ vpmnNetwork: event.target.value });
  }

  async getVpmnTadigFromApi(network: string) {
    this.backendApiService.callToApi(
      this.endpointsService.URL_GET_CAMPAIGN_TADIG + '&country=' + this.commonForm.get('vpmnCountry').value +
      '&operator=' + network).
      subscribe(response => {
        this.vpmnTadigArrayDetails = response;
      });
  }

  setVpmTadigDetails(event: any) {
    this.selectedVpmnTadig.emit({ vpmnTadig: event.target.value });
  }

  reset() {
    this.createForm();
  }

  setDropDownValues(vpmnCountry, vpmnNetwork, vpmnTadig, hpmnCountry, hpmnNetwork, hpmnTadig) {
    this.createForm();
    if (vpmnCountry) {
      this.getVpmnNetworkList(vpmnCountry).then();
    }
    this.commonForm.patchValue({
      vpmnCountry: [vpmnCountry],
      vpmnNetwork: [vpmnNetwork],
      vpmnTadig: [vpmnTadig],
      hpmnCountry: ['1'],
      hpmnNetwork: ['1'],
      hpmnTadig: ['1'],
    });

  }

}
